import { FC } from 'react'
import { SelectInput } from 'react-admin'

interface PropTypes {
  fieldId: string
  source: string
  choices: {
    id: string | boolean | number
    name: string
  }[]
  onChange?: (value: any) => object
}

const SelectFilter: FC<PropTypes> = ({ source, choices, fieldId, onChange }) => {
  return (
    <SelectInput
      choices={choices}
      label={false}
      source={`${source}.value.${fieldId}`}
      variant="outlined"
      margin={'none'}
      onChange={onChange}
      defaultValue={null}
    />
  )
}

export default SelectFilter

